// SAD-900: compact labels for a deliverable's PWS / CLIN / source-document chips.
/** Award / SOW / By hand — the duty's origin in a few words. */ export function originLabel(origin) {
    if (origin === 'sow') return 'SOW';
    if (origin === 'manual') return 'By hand';
    return 'Award';
}
/** "PWS 5.2" or "PWS 5.2 A"; "" when no PWS reference. */ export function pwsChipLabel(pwsRef, letter = '') {
    const ref = (pwsRef ?? '').trim();
    if (!ref) return '';
    const L = (letter ?? '').trim();
    return L ? `PWS ${ref} ${L}` : `PWS ${ref}`;
}
/** Pull a mod number ("P00001") out of a document title. */ export function modNumberFromTitle(title) {
    return title.match(/\b([A-Z]\d{4,5})\b/i)?.[1]?.toUpperCase() ?? '';
}
/**
 * Chip text for the duty's source document: a mod number when the title
 * carries one (P00001), else the document title/file name, else the origin
 * word (Award / SOW / By hand) when no document is linked.
 */ export function sourceDocChipLabel(doc, origin) {
    if (!doc) return originLabel(origin);
    const mod = modNumberFromTitle(doc.title ?? '');
    if (mod) return mod;
    const name = (doc.title || doc.fileName || '').trim();
    if (name) return name;
    const cat = (doc.category ?? '').trim();
    if (cat) return cat;
    return originLabel(origin);
}
